import React, { createContext, useContext, useState } from 'react';
import { createReactiveContext } from '../../../../../helpers/reactiveContext';

const { Provider, useSelector, useMethods } = createReactiveContext();
const MethodsContext = createContext();

const baseDefault = { isOpen: false };

export const useModalWatch = ({
  name,
  defaultValue = baseDefault,
  selector,
  isEqual,
}) =>
  useSelector((state) => {
    const value =
      typeof selector === 'function'
        ? selector(state[name])
        : state[name] ?? defaultValue;
    return value;
  }, isEqual);

export const useModalMethods = () => useContext(MethodsContext);

export const ModalProvider = ({ children }) => (
  <Provider>
    <ModalMethods>{children}</ModalMethods>
  </Provider>
);

function ModalMethods({ children }) {
  const { setValue, getValue } = useMethods();

  const [methods] = useState(() => {
    return {
      open: (name, props) => {
        setValue(name, { isOpen: true, props });
      },

      close: (name) => {
        setValue(name, { isOpen: false });
      },

      closeAndKeepProps: (name) => {
        setValue(name, (prev) => ({ ...prev, isOpen: false }));
      },

      removeProps: (name) => {
        setValue(name, (prev) => {
          const { props, ...rest } = prev ?? {};
          return rest;
        });
      },

      updateProps: (name, props) => {
        setValue(name, (prev) => ({ ...prev, props }));
      },

      getProps: (name) => {
        return getValue(name)?.props;
      },

      getState: (name) => {
        return getValue(name);
      },
    };
  });

  return (
    <MethodsContext.Provider value={methods}>
      {children}
    </MethodsContext.Provider>
  );
}
